






























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getSchoolInfo } from '@/utils/utils';
import config from '@/school.config';
import fields from '@/fields.config';
import moment from 'moment';

@Component
export default class StudentDetail extends Vue {
  @Prop() public studentDetailInfo!: any;
  public moment = moment;
  public config = config;
  public fields = fields;

  public get school() {
    return getSchoolInfo().shortName;
  }

  public get fieldsType() {
    return this.school === 'kcscd' ? 'kcscd' : 'default';
  }

  public get locale(): string {
    return this.$i18n.locale;
  }
}
